// extracted by mini-css-extract-plugin
export var button = "_mw-0";
export var donut = "_mw-1";
export var donutFill = "_mw-3";
export var donutTrack = "_mw-2";